import { TableHead as FBTableHead } from "flowbite-react";

const TableHead = (props) => {
  return <FBTableHead {...props}>{props.children}</FBTableHead>;
};

export default TableHead;